import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SearchComponent } from './search/search.component';
import { DocumentComponent } from './document/document.component';
import { OtpComponent } from './otp/otp.component';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { DocumentListComponent } from './document-list/document-list.component';

import { AuthenticationGuard } from './core/guard/authentication.guard';

const routes: Routes = [
  { path: '', redirectTo: '/search', pathMatch: 'full' },
  { path: 'search', component: SearchComponent, canActivate: [AuthenticationGuard] },
  { path: 'renewal', component: OtpComponent },
  { path: 'document/list', component: DocumentListComponent, canActivate: [AuthenticationGuard] },
  { path: 'document/:documentInfo', component: DocumentComponent, canActivate: [AuthenticationGuard] },
  { path: 'error', component: ErrorMessageComponent },
  { path: 'error/:errorType', component: ErrorMessageComponent },
  { path: '**', redirectTo: 'search' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
